var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnavailableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "9px",
    viewBox: "0 0 9 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03a-Dashboard---Few-Available-(Revised)-2",
    transform: "translate(-1098, -583)",
    stroke: "#FF7800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28-Copy",
    transform: "translate(1048, 563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(50, 20)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.5,
    cy: 4.5,
    r: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.40934066,
    y1: 7.59065934,
    x2: 7.59065934,
    y2: 1.40934066,
    id: "Line-3"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnavailableIcon);
export default __webpack_public_path__ + "static/media/unavailable-icon.d43e0b7255f024b6cee225b89ece4636.svg";
export { ForwardRef as ReactComponent };